import Modal from 'common/components/Modal/Modal';
import React, { FC } from 'react';
import { useKey } from 'react-use';

type Props = {
  networkNames: string[];
  close: () => void;
  change: () => void;
};

const NetworkWarningModalContainer: FC<Props> = (props) => {
  useKey('Escape', () => props.close());

  const close = (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event?.preventDefault;
    props.close();
  };

  const change = (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event?.preventDefault;
    props.change();
  };

  return (
    <Modal
      header={<div className=" font-medium text-2xl primary-text-color text-center mt-3">Network Changed</div>}
      isShowing={!!props.networkNames.length}
      hide={close}
      autoHeight
    >
      <div className="py-4 px-7 text-center primary-text-color">
        <p>Confirm network change in your wallet.</p>
        <button 
          type="button" 
          onClick={change} 
          className=" h-10 px-4 my-4 rounded-[10px] secondary-button-bg-color secondary-button-color">
          Change Network
        </button>
      </div>
    </Modal>
  );
};

export default NetworkWarningModalContainer;
